import { Box, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { Colors } from "../../helpers/Consts";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

type Props = {
  open: boolean;
  handleClose: () => void;
  fullScreen:boolean;
};

export default function FoodDialogError({open, handleClose, fullScreen}: Props){
  return(<Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => {
        handleClose();
      }}
      maxWidth={"lg"}
    >
      <DialogTitle color={Colors.orangePrimary}>
        <Box display="flex" alignItems="center">
          <Box>
            <IconButton
              color="primary"
              onClick={()=>handleClose()}
            >
              <ArrowBackIosIcon fill={Colors.orangePrimary} />
            </IconButton>
          </Box>
          <Box
            flexGrow={1}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Tivemos um problema
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <>
          Desculpe, não foi possível carregar os dados do produto.
        </>
      </DialogContent>
    </Dialog>
  );
}